import * as Base from '@base';
import { Block, useTranslation } from '@common';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { FooterProps } from './types';

export function Footer(props: FooterProps): ReactElement {
  const [t] = useTranslation();

  return (
    <div className={styles.footer}>
      <Block if={props.step === 0} >
        <Base.Button type='primary' onClick={props.onDownload}>{t('下载模板')}</Base.Button>
      </Block>
      <Block if={props.step === 1 || props.step === 2}>
        <Base.Button type='primary' onClick={props.onPrev}>{t('上一步')}</Base.Button>
      </Block>
      <span className={styles.splitter} />
      <Block if={props.step === 0} >
        <Base.Space>
          <Base.Button onClick={props.onCancel}>{t('取消')}</Base.Button>
          <Base.Button type='primary' onClick={props.onNext}>{t('下一步')}</Base.Button>
        </Base.Space>
      </Block>
      <Block if={props.step === 1}>
        <Base.Button onClick={props.onCancel}>{t('取消')}</Base.Button>
      </Block>
      <Block if={props.step === 2} >
        <Base.Space>
          <Base.Button onClick={props.onCancel}>{t('取消')}</Base.Button>
          <Base.Button
            type='primary'
            disabled={props.error}
            onClick={props.onSubmit}
          >
            {t('提交')}
          </Base.Button>
        </Base.Space>
      </Block>
      <Block if={props.step === 3} >
        <Base.Button type='primary' onClick={props.onCancel}>{t('完成')}</Base.Button>
      </Block>
    </div>
  );
}
